const ReviewWarning = () => null;

export default ReviewWarning;
